import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { RelativePeriod } from '@components/comparison-period-selector/Types';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { MainFiltersRoActionType } from '@state/actions/Type';
import { getSessionStorage, setSessionStorage, StorageKey } from '@utils/StorageUtils';
import { MainFiltersRoAction } from '@state/actions/main-filter-retailer-overview/MainFiltersRetailerOverviewAction';
import { BaseTimePeriod } from '@services/FiltersTypes';
import { CustomMonthsPeriodState } from '../main-filter/MainFiltersReducer';

export interface MainFilterStateRO {
  timeFrame: Periodicity | null;
  period: BaseTimePeriod | null;
  comparisonPeriod: RelativePeriod | null;
  selectedGrowthType: GrowthTypes;
  country?: string;
  customMonthsPeriodState?: CustomMonthsPeriodState;
}

export const defaultState: MainFilterStateRO = {
  timeFrame: null,
  period: null,
  comparisonPeriod: null,
  selectedGrowthType: GrowthTypes.percentage,
  country: '',
  customMonthsPeriodState: {
    period: null,
    comparisonPeriod: null,
  },
};

const getInitialState = () => {
  const rawRetailerOverviewMainFilters = getSessionStorage(StorageKey.RetailerOverviewMainFilters);

  if (rawRetailerOverviewMainFilters !== null) {
    const storageRetailerOverviewMainFilters = JSON.parse(rawRetailerOverviewMainFilters);

    if (
      storageRetailerOverviewMainFilters.period &&
      storageRetailerOverviewMainFilters.timeFrame &&
      storageRetailerOverviewMainFilters.comparisonPeriod &&
      storageRetailerOverviewMainFilters.selectedGrowthType
    ) {
      return {
        timeFrame: storageRetailerOverviewMainFilters.timeFrame,
        period: storageRetailerOverviewMainFilters.period,
        comparisonPeriod: storageRetailerOverviewMainFilters.comparisonPeriod,
        selectedGrowthType: storageRetailerOverviewMainFilters.selectedGrowthType,
        country: storageRetailerOverviewMainFilters.country,
        customMonthsPeriodState: storageRetailerOverviewMainFilters.customMonthsPeriodState,
      };
    }
  }

  return Object.freeze(defaultState);
};

export type UpdateMainFiltersRoPayload = {
  timeFrame?: Periodicity;
  period?: BaseTimePeriod;
  comparisonPeriod?: RelativePeriod;
  selectedGrowthType?: GrowthTypes;
  country?: string;
  customMonthsPeriodState?: CustomMonthsPeriodState;
};

const MainFiltersRoReducer = (
  state: MainFilterStateRO = getInitialState(),
  action?: MainFiltersRoAction,
): MainFilterStateRO => {
  if (action) {
    const actionType = action.type;
    switch (actionType) {
      case MainFiltersRoActionType.UpdateMainFiltersRo: {
        const finalPayLoad = {
          ...state,
          ...action.payload,
        };
        setSessionStorage(StorageKey.RetailerOverviewMainFilters, JSON.stringify(finalPayLoad));
        return finalPayLoad;
      }
      case MainFiltersRoActionType.UpdateMFROPeriod:
      case MainFiltersRoActionType.UpdateMFROPeriodicity:
      case MainFiltersRoActionType.UpdateMFROCustomMonthsPeriodState:
      case MainFiltersRoActionType.UpdateMFROComparisonPeriod: {
        const field = findKey(actionType);

        const finalPayLoad = {
          ...state,
          [field]: action.payload,
        };
        setSessionStorage(StorageKey.RetailerOverviewMainFilters, JSON.stringify(finalPayLoad));
        return finalPayLoad;
      }
    }
  }

  // default
  return state;
};

const findKey = (actionType: MainFiltersRoActionType): keyof MainFilterStateRO => {
  switch (actionType) {
    case MainFiltersRoActionType.UpdateMFROPeriod: {
      return 'period';
    }
    case MainFiltersRoActionType.UpdateMFROPeriodicity: {
      return 'timeFrame';
    }
    case MainFiltersRoActionType.UpdateMFROComparisonPeriod: {
      return 'comparisonPeriod';
    }
    case MainFiltersRoActionType.UpdateMFROCustomMonthsPeriodState: {
      return 'customMonthsPeriodState';
    }
    default:
      throw new Error(`Find key: unsupported action type: ${actionType}`);
  }
};

export default MainFiltersRoReducer;
